import { factoryIdStorage } from "@/utils/storageLocal";

/**
 * LocalStorageからfactoryIdを取得する
 */
export const getFactoryId = () => {
  return factoryIdStorage.read();
};
